/**
|--------------------------------------------------
| Constants
|--------------------------------------------------
*/
export const LOGIN_SHOW_LOADING = 'LOGIN_SHOW_LOADING'
export const LOGIN_HIDE_LOADING = 'LOGIN_HIDE_LOADING'

/**
|--------------------------------------------------
| Handlers
|--------------------------------------------------
*/
const ActionHandler = {
  [LOGIN_SHOW_LOADING]: (currentState, action) => ({
    ...currentState,
    isLoading: true
  }),
  [LOGIN_HIDE_LOADING]: (currentState, action) => ({
    ...currentState,
    isLoading: false
  })
}

/**
|--------------------------------------------------
| Reducer
|--------------------------------------------------
*/
const initialState = {
  isLoading: false
}

export default function login (currentState = { ...initialState }, action) {
  const handler = ActionHandler[action.type]
  const nextState = handler ? handler(currentState, action) : currentState
  return nextState
}



// WEBPACK FOOTER //
// ./src/routes/Login/modules/reducer.js